import React from 'react'
import { SvgIcon } from '@material-ui/core'

const OlineIcon = (props) => {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="31.118" height="29.559" viewBox="0 0 31.118 29.559">
      <g fill="#e6332a" id="Group_5363" data-name="Group 5363" transform="translate(-96.75 -30.221)">
        <path id="Path_12460" data-name="Path 12460" className="cls-1" d="m117.873 41.818-4.007 2.863a2.68 2.68 0 0 1-3.114 0l-4.007-2.863a.75.75 0 0 0-.872 1.221l4.007 2.861a4.179 4.179 0 0 0 4.858 0l4.007-2.862a.75.75 0 0 0-.872-1.221z" />
        <path id="Path_12461" data-name="Path 12461" className="cls-1" d="M127.245 39.907a12.212 12.212 0 0 0-9.21-8.98l-.707-.157a23.217 23.217 0 0 0-10.038 0l-.708.157a12.211 12.211 0 0 0-9.209 8.98 21.121 21.121 0 0 0 0 10.186 12.21 12.21 0 0 0 9.209 8.98l.708.157a23.186 23.186 0 0 0 10.038 0l.707-.157a12.211 12.211 0 0 0 9.21-8.98 21.146 21.146 0 0 0 0-10.186zm-9.534 17.7-.708.157a21.705 21.705 0 0 1-9.389 0l-.707-.157a10.713 10.713 0 0 1-8.078-7.877 19.622 19.622 0 0 1 0-9.463 10.713 10.713 0 0 1 8.078-7.878l.707-.156a21.674 21.674 0 0 1 9.389 0l.708.156a10.713 10.713 0 0 1 8.078 7.878 19.622 19.622 0 0 1 0 9.463 10.713 10.713 0 0 1-8.078 7.879z" />
      </g>
      {' '}

    </SvgIcon>
  )
}

export default OlineIcon
